import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { TerritoryDataGate } from '@/components/territory/TerritoryDataGate';

export function AppShell() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto bg-surface-page">
          {/* Gate global : appel à l'ingestion quand le territoire actif
              n'a que ses données de base (sinon ne rend rien). */}
          <TerritoryDataGate />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
